// import React, { useState } from 'react';
// import './Profile.css'; // Import the dedicated CSS file
// // AchievementBadge component for reusability
// const AchievementBadge = ({ icon, title, subtitle }) => {
//   return (
//     <div className="achievement-badge p-4 rounded-xl text-center transition-all duration-200 hover:scale-105">
//       <span className="text-5xl block mb-2">{icon}</span>
//       <p className="font-bold text-gray-800">{title}</p>
//       <p className="text-sm text-gray-600">{subtitle}</p>
//     </div>
//   );
// };

// // ProgressBar component for reusability
// const ProgressBar = ({ progress, type, label }) => {
//   const progressBarClass = `progress-bar-fill progress-bar-${type}`;
//   return (
//     <div>
//       <div className="progress-bar-container mt-1">
//         <div className={progressBarClass} style={{ width: `${progress}%` }}></div>
//       </div>
//       <p className="text-xs text-gray-600 mt-1">{label}</p>
//     </div>
//   );
// };


// const ProfileSection = () => {
//   // State for form inputs (example, can be expanded)
//   const [learningStyle, setLearningStyle] = useState('kinesthetic');
//   const [favoriteSubject, setFavoriteSubject] = useState('Science Experiments');
//   const [activityLevel, setActivityLevel] = useState('medium');
//   const [email, setEmail] = useState('alex.johnson@example.com');
//   const [phone, setPhone] = useState('+91 98765 43210');

//   const handleLearningPreferencesSubmit = (e) => {
//     e.preventDefault();
//     console.log('Learning Preferences Saved:', { learningStyle, favoriteSubject, activityLevel });
//     // Add logic to save preferences (e.g., API call)
//   };

//   const handleContactInfoSubmit = (e) => {
//     e.preventDefault();
//     console.log('Contact Info Updated:', { email, phone });
//     // Add logic to update contact info (e.g., API call)
//   };

//   const achievements = [
//     { icon: '🏆', title: 'Course Completion', subtitle: 'Personality Enrichment' },
//     { icon: '🌟', title: 'Star Student', subtitle: 'Top 10% in Class' },
//     { icon: '💡', title: 'Creative Thinker', subtitle: 'Awarded for Innovation' },
//     { icon: '🤝', title: 'Team Player', subtitle: 'Excellent Collaboration' },
//   ];

//   const recentActivity = [
//     { icon: '🗓️', text: 'Joined Class:', detail: 'Personality Enrichment - Class 20', color: 'text-blue-500' },
//     { icon: '✅', text: 'Completed Quiz:', detail: 'Module 1 Assessment', color: 'text-green-500' },
//     { icon: '🌟', text: 'Earned Badge:', detail: 'Creative Thinker', color: 'text-purple-500' },
//     { icon: '📚', text: 'Viewed Resource:', detail: 'Module 2 Workbook', color: 'text-orange-500' },
//   ];

//   const learningGoals = [
//     { title: 'Complete "Public Speaking" Module', progress: 60, label: '60% Completed', type: 'primary' },
//     { title: 'Master Active Listening Skills', progress: 85, label: '85% Progress', type: 'secondary' },
//     { title: 'Earn 5 New Badges', progress: 40, label: '2/5 Badges Earned', type: 'accent' },
//   ];

//   return (
//     <main className="flex-grow container mx-auto p-4 md:p-8 lg:max-w-screen-xl xl:max-w-screen-2xl grid grid-cols-1 lg:grid-cols-3 gap-6 font-inter">
//       <div className="lg:col-span-2 flex flex-col space-y-6">
//         {/* My Profile Card */}
//         <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform-gpu transition-all duration-300 hover:scale-[1.005]">
//           <div className="profile-card-header h-32 flex items-center justify-center text-white text-3xl font-extrabold relative">
//             <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-purple-500 opacity-80"></div>
//             <span className="relative z-10">My Profile</span>
//           </div>
//           <div className="p-6 -mt-16 relative z-20 flex flex-col items-center text-center">
//             <img className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg mb-4" src="https://placehold.co/128x128/a2d2ff/000000?text=Alex" alt="Alex Johnson Profile Picture" />
//             <p className="font-bold text-3xl text-gray-800 mb-1">Alex Johnson</p>
//             <p className="text-purple-600 text-lg mb-4">Aspiring Leader & Creative Thinker</p>
//             <button className="bg-pink-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-pink-700 transition-colors shadow-md mb-6">
//               Edit Profile
//             </button>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700 text-base w-full max-w-xl">
//               <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
//                 <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m0 0l7 7m-11 4v3m-6 0v-3m0-11v11a1 1 0 001 1h7a1 1 0 001-1V7a1 1 0 00-1-1h-7a1 1 0 00-1 1z"></path></svg>
//                 <p><span className="font-semibold">Grade:</span> 5th Grade</p>
//               </div>
//               <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
//                 <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"></path></svg>
//                 <p><span className="font-semibold">School:</span> Bright Minds Academy</p>
//               </div>
//               <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
//                 <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path></svg>
//                 <p><span className="font-semibold">Interests:</span> Reading, Drawing, Science</p>
//               </div>
//               <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
//                 <svg className="w-6 h-6 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2z"></path></svg>
//                 <p><span className="font-semibold">Joined:</span> January 2024</p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* My Achievements Section */}
//         <div className="bg-white rounded-2xl shadow-xl p-6 border-b-4 border-yellow-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
//           <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
//             <svg className="w-8 h-8 md:w-10 md:h-10 mr-3 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-12l2-2m0 0l7 7-7 7m-11 4v3m-2-2h4m5-12l2-2m0 0l7 7-7 7"></path></svg>
//             My Achievements
//           </h2>
//           <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
//             {achievements.map((badge, index) => (
//               <AchievementBadge key={index} icon={badge.icon} title={badge.title} subtitle={badge.subtitle} />
//             ))}
//           </div>
//           <button className="mt-6 w-full bg-yellow-500 text-white py-2 rounded-full font-semibold hover:bg-yellow-600 transition-colors shadow-md">View All Badges</button>
//         </div>
//           {/* My Learning Goals */}
//         <div className="bg-white rounded-2xl shadow-xl p-6 border-b-4 border-purple-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
//           <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
//             <svg className="w-8 h-8 md:w-10 md:h-10 mr-3 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 21v-4m0 0V5a2 2 0 012-2h6.5M3 17h9m1-8h7m-7 0a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1V9z"></path></svg>
//             My Learning Goals
//           </h2>
//           <ul className="space-y-3">
//             {learningGoals.map((goal, index) => (
//               <li key={index} className="flex items-center space-x-3 bg-gray-50 p-3 rounded-lg shadow-sm">
//                 <span className="text-xl text-green-500">🎯</span>
//                 <div className="flex-grow">
//                   <p className="font-semibold text-gray-800">{goal.title}</p>
//                   <ProgressBar progress={goal.progress} type={goal.type} label={goal.label} />
//                 </div>
//               </li>
//             ))}
//           </ul>
//           <button className="mt-6 w-full bg-purple-500 text-white py-2 rounded-full font-semibold hover:bg-purple-600 transition-colors shadow-md">Set New Goal</button>
//         </div>
//       </div>

//       <div className="lg:col-span-1 flex flex-col space-y-6">
//         {/* Learning Preferences */}
//         <div className="bg-white rounded-2xl shadow-xl p-6 border-b-4 border-green-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
//           <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
//             <svg className="w-8 h-8 md:w-10 md:h-10 mr-3 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
//             Learning Preferences
//           </h2>
//           <form onSubmit={handleLearningPreferencesSubmit} className="space-y-4">
//             <div>
//               <label htmlFor="learning-style" className="block text-gray-700 font-semibold mb-2">Preferred Learning Style:</label>
//               <select
//                 id="learning-style"
//                 name="learning-style"
//                 className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 transition-all duration-200"
//                 value={learningStyle}
//                 onChange={(e) => setLearningStyle(e.target.value)}
//               >
//                 <option value="visual">Visual (seeing)</option>
//                 <option value="auditory">Auditory (hearing)</option>
//                 <option value="kinesthetic">Kinesthetic (doing)</option>
//                 <option value="reading">Reading/Writing</option>
//               </select>
//             </div>
//             <div>
//               <label htmlFor="favorite-subject" className="block text-gray-700 font-semibold mb-2">Favorite Subject:</label>
//               <input
//                 type="text"
//                 id="favorite-subject"
//                 name="favorite-subject"
//                 value={favoriteSubject}
//                 onChange={(e) => setFavoriteSubject(e.target.value)}
//                 className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 transition-all duration-200"
//                 placeholder="e.g., Math, Art, Science"
//               />
//             </div>
//             <div>
//               <label className="block text-gray-700 font-semibold mb-2">Activity Level:</label>
//               <div className="flex items-center space-x-4">
//                 <label className="inline-flex items-center">
//                   <input
//                     type="radio"
//                     name="activity-level"
//                     value="low"
//                     className="form-radio text-green-600 h-5 w-5"
//                     checked={activityLevel === 'low'}
//                     onChange={(e) => setActivityLevel(e.target.value)}
//                   />
//                   <span className="ml-2 text-gray-700">Low</span>
//                 </label>
//                 <label className="inline-flex items-center">
//                   <input
//                     type="radio"
//                     name="activity-level"
//                     value="medium"
//                     className="form-radio text-green-600 h-5 w-5"
//                     checked={activityLevel === 'medium'}
//                     onChange={(e) => setActivityLevel(e.target.value)}
//                   />
//                   <span className="ml-2 text-gray-700">Medium</span>
//                 </label>
//                 <label className="inline-flex items-center">
//                   <input
//                     type="radio"
//                     name="activity-level"
//                     value="high"
//                     className="form-radio text-green-600 h-5 w-5"
//                     checked={activityLevel === 'high'}
//                     onChange={(e) => setActivityLevel(e.target.value)}
//                   />
//                   <span className="ml-2 text-gray-700">High</span>
//                 </label>
//               </div>
//             </div>
//             <button type="submit" className="w-full bg-green-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-green-600 transition-colors shadow-md">
//               Save Preferences
//             </button>
//           </form>
//         </div>

//         {/* Contact Information */}
//         <div className="bg-white rounded-2xl shadow-xl p-6 border-b-4 border-red-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
//           <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
//             <svg className="w-8 h-8 md:w-10 md:h-10 mr-3 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
//             Contact Information
//           </h2>
//           <form onSubmit={handleContactInfoSubmit} className="space-y-4">
//             <div>
//               <label htmlFor="email" className="block text-gray-700 font-semibold mb-2">Email Address:</label>
//               <input
//                 type="email"
//                 id="email"
//                 name="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 transition-all duration-200"
//               />
//             </div>
//             <div>
//               <label htmlFor="phone" className="block text-gray-700 font-semibold mb-2">Phone Number (Optional):</label>
//               <input
//                 type="tel"
//                 id="phone"
//                 name="phone"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value)}
//                 className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 transition-all duration-200"
//               />
//             </div>
//             <button type="submit" className="w-full bg-red-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-600 transition-colors shadow-md">
//               Update Contact Info
//             </button>
//           </form>
//         </div>

//         {/* Recent Activity */}
//         <div className="bg-white rounded-2xl shadow-xl p-6 border-b-4 border-blue-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
//           <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
//             <svg className="w-8 h-8 md:w-10 md:h-10 mr-3 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
//             Recent Activity
//           </h2>
//           <ul className="space-y-3">
//             {recentActivity.map((activity, index) => (
//               <li key={index} className="flex items-center space-x-3 bg-gray-50 p-3 rounded-lg shadow-sm">
//                 <span className={`text-xl ${activity.color}`}>{activity.icon}</span>
//                 <p className="text-gray-700"><span className="font-semibold">{activity.text}</span> {activity.detail}</p>
//               </li>
//             ))}
//           </ul>
//           <button className="mt-6 w-full bg-blue-500 text-white py-2 rounded-full font-semibold hover:bg-blue-600 transition-colors shadow-md">View All Activity</button>
//         </div>

      
//       </div>
//     </main>
//   );
// };
// export default ProfileSection;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Profile.css'; // Import the dedicated CSS file
import baseUrl from '../../config';
import cat from '../../Assets/avatar/cat.png'; // Example static image, replace with your own
import woman from '../../Assets/avatar/woman.png'; // Example static image, replace with your own
import man from '../../Assets/avatar/man.png'; // Example static image, replace with your own

import {
  PhoneIcon,               // For Contact Information header
  ListBulletIcon,         // For Recent Activity header
  AcademicCapIcon,        // For Daily Quiz activity
  CalendarIcon,           // For general Class Schedule activity
  CheckCircleIcon,        // For Class Completed activity
  XCircleIcon,            // For Class Missed activity
  ArrowPathIcon,          // For Class Rescheduled activity
  TrophyIcon,             // For Unlocked Achievements header and individual achievement
  PresentationChartBarIcon, // For Progress Overview header
  SparklesIcon            // General fallback icon for activities
} from '@heroicons/react/24/outline'; // Using outline versions for consistency

const AVATAR_PATHS = [
  cat,  
  woman,
  man,  ];
// AchievementBadge component
const AchievementBadge = ({ icon, title, subtitle }) => {
  return (
    <div className="achievement-badge p-4 rounded-xl text-center transition-all duration-200 hover:scale-105">
      <span className="text-5xl block mb-2">{icon}</span>
      <p className="font-bold text-gray-800">{subtitle}</p>
    </div>
  );
};

// ProgressBar component
const ProgressBar = ({ progress, type, label }) => {
  const progressBarClass = `progress-bar-fill progress-bar-${type}`;
  return (
    <div>
      <div className="progress-bar-container mt-1">
        <div className={progressBarClass} style={{ width: `${progress}%` }}></div>
      </div>
      <p className="text-xs text-gray-600 mt-1">{label}</p>
    </div>
  );
};

const ProfileSection = () => {
  // State for fetched profile data
   const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profileData, setProfileData] = useState(null);

  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [grade, setGrade] = useState('');
  const [school, setSchool] = useState('oratrics learning solution');
  const [interests, setInterests] = useState('Reading, Drawing, Science');
  const [joined, setJoined] = useState('January 2024');

  const [bio, setBio] = useState('');
  const [dob, setDob] = useState('');
  const [gender, setGender] = useState('');
  const [nationality, setNationality] = useState('');
  const [parentName, setParentName] = useState('');
  const [skills, setSkills] = useState([]);
  const [languages, setLanguages] = useState([]);

  const [selectedAvatarPath, setSelectedAvatarPath] = useState('');
  const [showAvatarModal, setShowAvatarModal] = useState(false);

  const [learningStyle, setLearningStyle] = useState('');
  const [favoriteSubject, setFavoriteSubject] = useState('');
  const [activityLevel, setActivityLevel] = useState('');

  // console.log(selectedAvatarPath, "selectedAvatarPath"); // Keep for debugging

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('Authentication token not found. Please log in.');
          setLoading(false);
          return;
        }

        const response = await axios.get(`${baseUrl}api/students/v2/profile`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setProfile(response.data);

        // Initialize states with fetched data
        setName(response.data.name || '');
        setEmail(response.data.email || '');
        setPhone(response.data.contact || '');
        setGrade(response.data.grade || '');
        setBio(response.data.bio || '');
        setDob(response.data.dob ? new Date(response.data.dob).toISOString().split('T')[0] : '');
        setGender(response.data.gender || '');
        setNationality(response.data.nationality || '');
        setParentName(response.data.parentName || '');
        setSkills(response.data.skills || []);
        setLanguages(response.data.languages || []);

        // Set selected avatar path: Use fetched path, or first available if none.
        // Ensure that if response.data.avatar is null/undefined, it defaults to a valid path.
        setSelectedAvatarPath(response.data.avatar || AVATAR_PATHS[0]);


        setLearningStyle(response.data.learningStyle || '');
        setFavoriteSubject(response.data.favoriteSubject || '');
        setActivityLevel(response.data.activityLevel || '');

        setLoading(false);
      } catch (err) {
        console.error('Error fetching profile:', err);
        setError(err.response?.data?.message || 'Failed to load profile data. Please try again.');
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const updateData = {
      name,
      email,
      contact: phone,
      grade,
      bio,
      dob,
      gender,
      nationality,
      parentName,
      // Ensure these are sent as arrays, the backend will handle JSON.parse if needed
      skills: skills,
      languages: languages,
      learningStyle,
      favoriteSubject,
      activityLevel,
      avatar: selectedAvatarPath // This is the correct path string for the backend
    };

    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(`${baseUrl}api/students/v2/profile`, updateData, {
        headers: {
          'Content-Type': 'application/json', // Send as JSON as no file upload via FormData
          Authorization: `Bearer ${token}`
        }
      });
      setProfile(response.data);
      setEditMode(false);
      setLoading(false);
      alert('Profile updated successfully!');
    } catch (err) {
      console.error('Error updating profile:', err.response ? err.response.data : err.message);
      console.log('Error updating profile:', err.response ? err.response.data : err.message); // Duplicated, can remove one

      setError(err.response?.data?.message || 'Failed to update profile. Please try again.');
      setLoading(false);
    }
  };


   useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const token = localStorage.getItem('token'); // Get token from local storage

        if (!token) {
          setError('No authentication token found. Please log in.');
          setLoading(false);
          return;
        }

        const response = await fetch(baseUrl + 'api/students/v2/profile-data', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          if (response.status === 401) {
            setError('Unauthorized: Please log in again.');
            // Optionally, redirect to login page
            // window.location.href = '/login';
          } else {
            const errorData = await response.json();
            setError(errorData.message || 'Failed to fetch profile data.');
          }
          setLoading(false);
          return;
        }

        const data = await response.json();
        setProfileData(data);
     
      } catch (err) {
        console.error('Error fetching profile data:', err);
        setError('An unexpected error occurred.');
      } finally {
        setLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  const handleAvatarSelect = (path) => {
    setSelectedAvatarPath(path);
    setShowAvatarModal(false);
  };


   const mapActivityIcon = (type, detail) => {
    switch (type) {
      case 'Daily Quiz':
        return <AcademicCapIcon />;
      case 'Class':
        if (detail && detail.includes('Completed')) return <CheckCircleIcon />;
        if (detail && detail.includes('Missed')) return <XCircleIcon />;
        if (detail && detail.includes('Rescheduled')) return <ArrowPathIcon />;
        return <CalendarIcon />; // Default for scheduled classes
      default:
        return <SparklesIcon />; // General icon for unmapped activities
    }
  };



  // --- Conditional Rendering for Loading/Error ---
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50 font-sans p-6">
        <div className="flex flex-col items-center p-8 bg-white rounded-3xl shadow-xl">
          <div className="animate-bounce bg-blue-500 p-4 rounded-full mb-4">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path></svg>
          </div>
          <p className="text-xl text-gray-700 font-semibold">Loading profile data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <main className="flex-grow container mx-auto p-4 md:p-8 flex justify-center items-center h-screen">
        <p className="text-xl text-red-600">{error}</p>
      </main>
    );
  }

  if (!profile) {
    return (
      <main className="flex-grow container mx-auto p-4 md:p-8 flex justify-center items-center h-screen">
        <p className="text-xl text-gray-700">No profile data found.</p>
      </main>
    );
  }

    if (!profileData) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-100">
        <div className="text-xl text-gray-600 font-semibold">No profile data available.</div>
      </div>
    );
  }

  // Frontend-specific transformation for recentActivity based on your backend output
  const formattedRecentActivity = profileData.recentActivity.map(activity => ({
    ...activity,
    icon: mapActivityIcon(activity.type, activity.detail), // Map appropriate icon
  }));

  // Sample data for badges, activity, goals (can be fetched from backend)
 

  
console.log(`${baseUrl.replace(/\/$/, '')}${selectedAvatarPath}`, "selectedAvatarPath"); // Keep for debugging
  return (
    <main className="flex-grow container mx-auto p-4 md:p-8 lg:max-w-screen-xl xl:max-w-screen-2xl grid grid-cols-1 lg:grid-cols-3 gap-6 font-inter">
      <div className="lg:col-span-2 flex flex-col space-y-6">
        {/* My Profile Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform-gpu transition-all duration-300 hover:scale-[1.005]">
          <div className="profile-card-header h-32 flex items-center justify-center text-white text-3xl font-extrabold relative">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-purple-500 opacity-80"></div>
            <span className="relative z-10">My Profile</span>
          </div>
          <div className="p-6 -mt-16 relative z-20 flex flex-col items-center text-center">
            <div className="relative mb-4">
                  <img
                className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg"
  src={selectedAvatarPath} // NO BASE_URL HERE!
                alt={`${profile.name} Profile`}
                onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/128x128/a2d2ff/000000?text=Default"; }} // Fallback image
              />
              {editMode && (
                <button
                  onClick={() => setShowAvatarModal(true)}
                  className="absolute bottom-0 right-0 bg-blue-500 text-white rounded-full p-2 cursor-pointer shadow-md hover:bg-blue-600 transition-colors"
                  title="Change Avatar"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.808-1.212A2 2 0 0110.36 4h3.28a2 2 0 011.664.89l.808 1.212c.749 1.124 1.897 1.124 2.646 0l.808-1.212A2 2 0 0118.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                </button>
              )}
            </div>

            {editMode ? (
              <>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="font-bold text-3xl text-gray-800 mb-1 text-center border-b border-gray-300 focus:outline-none"
                />
                <input
                  type="text"
                  value={profile.role === 'student' ? `${grade} Grade` : profile.role} // Display editable grade
                  disabled // Display only, not editable here (grade is in main form)
                  className="text-purple-600 text-lg mb-4 text-center border-b border-gray-300 focus:outline-none"
                />
              </>
            ) : (
              <>
                <p className="font-bold text-3xl text-gray-800 mb-1">{profile.name}</p>
                <p className="text-purple-600 text-lg mb-4">{profile.role === 'student' ? `${profile.grade} Grade` : profile.role}</p>
              </>
            )}

            <button
              onClick={() => setEditMode(!editMode)}
              className="bg-pink-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-pink-700 transition-colors shadow-md mb-6"
            >
              {editMode ? 'Cancel Edit' : 'Edit Profile'}
            </button>

            {editMode && (
              <form onSubmit={handleProfileUpdate} className="w-full max-w-xl space-y-4 mb-6">
                {/* Editable Fields for Main Profile Card */}
                <div>
                  <label htmlFor="grade" className="block text-gray-700 font-semibold mb-2">Grade:</label>
                  <input
                    type="text"
                    id="grade"
                    value={grade}
                    onChange={(e) => setGrade(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                  />
                </div>
                <div>
                  <label htmlFor="school" className="block text-gray-700 font-semibold mb-2">School:</label>
                  <input
                    type="text"
                    id="school"
                    value={school}
                    onChange={(e) => setSchool(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                    disabled // Assuming school is not meant to be updated
                  />
                </div>
                <div>
                  <label htmlFor="interests" className="block text-gray-700 font-semibold mb-2">Interests (comma-separated):</label>
                  <input
                    type="text"
                    id="interests"
                    value={interests}
                    onChange={(e) => setInterests(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                  />
                </div>
                <div>
                  <label htmlFor="dob" className="block text-gray-700 font-semibold mb-2">Date of Birth:</label>
                  <input
                    type="date"
                    id="dob"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                  />
                </div>
                <div>
                  <label htmlFor="gender" className="block text-gray-700 font-semibold mb-2">Gender:</label>
                  <select
                    id="gender"
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="nationality" className="block text-gray-700 font-semibold mb-2">Nationality:</label>
                  <input
                    type="text"
                    id="nationality"
                    value={nationality}
                    onChange={(e) => setNationality(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                  />
                </div>
                {profile.role === 'student' && (
                  <div>
                    <label htmlFor="parentName" className="block text-gray-700 font-semibold mb-2">Parent's Name:</label>
                    <input
                      type="text"
                      id="parentName"
                      value={parentName}
                      onChange={(e) => setParentName(e.target.value)}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                    />
                  </div>
                )}
                <div>
                  <label htmlFor="bio" className="block text-gray-700 font-semibold mb-2">Bio:</label>
                  <textarea
                    id="bio"
                    value={bio}
                    onChange={(e) => setBio(e.target.value)}
                    rows="4"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                  ></textarea>
                </div>
                <div>
                  <label htmlFor="skills" className="block text-gray-700 font-semibold mb-2">Skills (comma-separated):</label>
                  <input
                    type="text"
                    id="skills"
                    value={skills.join(', ')}
                    onChange={(e) => setSkills(e.target.value.split(',').map(s => s.trim()))}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                  />
                </div>
                <div>
                  <label htmlFor="languages" className="block text-gray-700 font-semibold mb-2">Languages (comma-separated):</label>
                  <input
                    type="text"
                    id="languages"
                    value={languages.join(', ')}
                    onChange={(e) => setLanguages(e.target.value.split(',').map(l => l.trim()))}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                  />
                </div>

                <button type="submit" className="w-full bg-blue-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-700 transition-colors shadow-md">
                  Save Changes
                </button>
              </form>
            )}

            {/* Display Fields (Always visible when not in edit mode) */}
            {!editMode && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700 text-base w-full max-w-xl">
                <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
                  <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m0 0l7 7m-11 4v3m-6 0v-3m0-11v11a1 1 0 001 1h7a1 1 0 001-1V7a1 1 0 00-1-1h-7a1 1 0 00-1 1z"></path></svg>
                  <p><span className="font-semibold">Grade:</span> {profile.grade}</p>
                </div>
                <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
                  <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"></path></svg>
                  <p><span className="font-semibold">School:</span> {school}</p>
                </div>
                <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
                  <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path></svg>
                  <p><span className="font-semibold">Interests:</span> {interests}</p>
                </div>
                <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
                  <svg className="w-6 h-6 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2z"></path></svg>
                  <p><span className="font-semibold">Joined:</span> {joined}</p>
                </div>
                {profile.dob && (
                  <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
                    <p><span className="font-semibold">DOB:</span> {new Date(profile.dob).toLocaleDateString()}</p>
                  </div>
                )}
                {profile.gender && (
                  <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
                    <p><span className="font-semibold">Gender:</span> {profile.gender}</p>
                  </div>
                )}
                {profile.nationality && (
                  <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
                    <p><span className="font-semibold">Nationality:</span> {profile.nationality}</p>
                  </div>
                )}
                {profile.parentName && (
                  <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm">
                    <p><span className="font-semibold">Parent:</span> {profile.parentName}</p>
                  </div>
                )}
                {profile.bio && (
                  <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm col-span-1 md:col-span-2">
                    <p><span className="font-semibold">Bio:</span> {profile.bio}</p>
                  </div>
                )}
                {profile.skills && profile.skills.length > 0 && (
                  <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm col-span-1 md:col-span-2">
                    <p><span className="font-semibold">Skills:</span> {profile.skills.join(', ')}</p>
                  </div>
                )}
                {profile.languages && profile.languages.length > 0 && (
                  <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg shadow-sm col-span-1 md:col-span-2">
                    <p><span className="font-semibold">Languages:</span> {profile.languages.join(', ')}</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Achievements */}
       {/* Unlocked Batches Card */}
   
        
            <div className="md:col-span-2 bg-white rounded-2xl shadow-xl p-6 border-b-4 border-blue-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
            {/* Using PresentationChartBarIcon from Heroicons for Progress Overview header */}
            <PresentationChartBarIcon className="w-8 h-8 md:w-10 md:h-10 mr-3 text-blue-500" />
            Progress Overview
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-center">
            <div className="p-4 bg-blue-50 rounded-lg shadow-sm">
              <p className="text-sm text-gray-600">Completed Classes</p>
              <p className="text-3xl font-bold text-blue-700">{profileData.completedClasses}</p>
            </div>
            <div className="p-4 bg-blue-50 rounded-lg shadow-sm">
              <p className="text-sm text-gray-600">Total Booked Classes</p>
              <p className="text-3xl font-bold text-blue-700">{profileData.totalBookedClasses}</p>
            </div>
            <div className="p-4 bg-blue-50 rounded-lg shadow-sm">
              <p className="text-sm text-gray-600">Compliance Status</p>
              <p className={`text-3xl font-bold ${profileData.complianceStatus === 'compliant' ? 'text-green-700' : 'text-orange-700'}`}>
                {profileData.complianceStatus.charAt(0).toUpperCase() + profileData.complianceStatus.slice(1)}
              </p>
            </div>
          </div>
        </div>
               <div className="md:col-span-2 bg-white rounded-2xl shadow-xl p-6 border-b-4 border-green-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
            <svg className="w-8 h-8 md:w-10 md:h-10 mr-3 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.002 2.002m0 0v.5l-2.002 2.002M12 21h2a2 2 0 002-2v-2a2 2 0 00-2-2h-2m-4-2.5l2-2.5m0 0V8.5m-2 4h4"></path></svg>
            Unlocked Achievements
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {profileData.unlockedBatches.length > 0 ? (
              profileData.unlockedBatches.map((batch, index) => (
                <div key={index} className="p-4 bg-green-50 rounded-lg shadow-sm flex items-center space-x-3 hover:bg-green-100 transition-colors">
                  <span className="text-3xl text-green-600">🏆</span> {/* Trophy icon */}
                  <div>
                    <h3 className="font-semibold text-gray-800">{batch.title}</h3>
                    <p className="text-sm text-gray-600">Achieved on: {new Date(batch.dateAssigned).toLocaleDateString()}</p>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-gray-600 text-center col-span-full">No achievements unlocked yet. Keep up the great work!</p>
            )}
          </div>
        </div>

        {/* Recent Activity */}
    

        {/* My Learning Goals */}
        {/* <div className="bg-white rounded-2xl shadow-xl p-6 border-b-4 border-purple-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
            <svg className="w-8 h-8 md:w-10 md:h-10 mr-3 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0h.01M9 19H7a2 2 0 01-2-2v-6a2 2 0 012-2h2m3-23v6a2 2 0 002 2h2a2 2 0 002-2V3a2 2 0 00-2-2h-2a2 2 0 00-2 2zm0 0h.01M9 19H7a2 2 0 01-2-2v-6a2 2 0 012-2h2m3-23v6a2 2 0 002 2h2a2 2 0 002-2V3a2 2 0 00-2-2h-2a2 2 0 00-2 2zm0 0H5v14a2 2 0 002 2h2a2 2 0 002-2V5m3 21h2a2 2 0 002-2v-2a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2z"></path></svg>
            My Learning Goals
          </h2>
          <div className="space-y-5">
            {learningGoals.map((goal, index) => (
              <div key={index}>
                <p className="font-semibold text-gray-700 mb-1">{goal.title}</p>
                <ProgressBar progress={goal.progress} type={goal.type} label={goal.label} />
              </div>
            ))}
          </div>
        </div> */}

      </div>

      <div className="lg:col-span-1 flex flex-col space-y-6">
        {/* Learning Preferences */}
        {/* <div className="bg-white rounded-2xl shadow-xl p-6 border-b-4 border-indigo-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
            <svg className="w-8 h-8 md:w-10 md:h-10 mr-3 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m12.728 0l-.707.707M6 18H4a2 2 0 00-2 2v2h20v-2a2 2 0 00-2-2h-2M12 5a4 4 0 110 8 4 4 0 010-8z"></path></svg>
            Learning Preferences
          </h2>
          <form onSubmit={handleProfileUpdate} className="space-y-4">
            <div>
              <label htmlFor="learningStyle" className="block text-gray-700 font-semibold mb-2">Preferred Learning Style:</label>
              <select
                id="learningStyle"
                name="learningStyle"
                value={learningStyle}
                onChange={(e) => setLearningStyle(e.target.value)}
                disabled={!editMode}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-200"
              >
                <option value="">Select a style</option>
                <option value="visual">Visual (seeing)</option>
                <option value="auditory">Auditory (hearing)</option>
                <option value="kinesthetic">Kinesthetic (doing)</option>
                <option value="reading_writing">Reading/Writing</option>
              </select>
            </div>
            <div>
              <label htmlFor="favoriteSubject" className="block text-gray-700 font-semibold mb-2">Favorite Subject/Topic:</label>
              <input
                type="text"
                id="favoriteSubject"
                name="favoriteSubject"
                value={favoriteSubject}
                onChange={(e) => setFavoriteSubject(e.target.value)}
                disabled={!editMode}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-200"
              />
            </div>
            <div>
              <label htmlFor="activityLevel" className="block text-gray-700 font-semibold mb-2">Preferred Activity Level:</label>
              <select
                id="activityLevel"
                name="activityLevel"
                value={activityLevel}
                onChange={(e) => setActivityLevel(e.target.value)}
                disabled={!editMode}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all duration-200"
              >
                <option value="">Select level</option>
                <option value="low">Low (more reading/listening)</option>
                <option value="medium">Medium (some interactive tasks)</option>
                <option value="high">High (lots of hands-on activities)</option>
              </select>
            </div>
            {editMode && (
              <button type="submit" className="w-full bg-indigo-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-indigo-600 transition-colors shadow-md">
                Save Preferences
              </button>
            )}
          </form>
        </div> */}

        {/* Contact Information */}
        <div className="bg-white rounded-2xl shadow-xl p-6 border-b-4 border-red-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
            <svg className="w-8 h-8 md:w-10 md:h-10 mr-3 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
            Contact Information
          </h2>
          <form onSubmit={handleProfileUpdate} className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-gray-700 font-semibold mb-2">Email Address:</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={!editMode}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 transition-all duration-200"
              />
            </div>
            <div>
              <label htmlFor="phone" className="block text-gray-700 font-semibold mb-2">Phone Number (Optional):</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                disabled={!editMode}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 transition-all duration-200"
              />
            </div>
            {editMode && (
              <button type="submit" className="w-full bg-red-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-600 transition-colors shadow-md">
                Update Contact Info
              </button>
            )}
          </form>
        </div>

         {/* Recent Activity Card */}
        <div className="bg-white rounded-2xl shadow-xl p-6 border-b-4 border-yellow-500 transform-gpu transition-all duration-300 hover:scale-[1.005]">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-4 flex items-center">
            {/* Using ListBulletIcon from Heroicons for Recent Activity header */}
            <ListBulletIcon className="w-8 h-8 md:w-10 md:h-10 mr-3 text-yellow-500" />
            Recent Activity
          </h2>
          <div className="space-y-4">
            {formattedRecentActivity.length > 0 ? (
              formattedRecentActivity.map((activity, index) => (
                <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg shadow-sm hover:bg-yellow-50 transition-colors">
                  {/* Render the specific Heroicon for the activity */}
                  <span className={`w-6 h-6 mr-3 ${activity.color}`}>
                    {activity.iconComponent}
                  </span>
                  <p className="text-gray-700"><span className="font-semibold">{activity.text}</span> {activity.detail}</p>
                </div>
              ))
            ) : (
              <p className="text-gray-600 text-center">No recent activity to display.</p>
            )}
          </div>
        </div>
      
      </div>

      {/* Avatar Selection Modal */}
      {showAvatarModal && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex justify-center items-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-lg relative">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">Select an Avatar</h3>
            <button
              onClick={() => setShowAvatarModal(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </button>
            <div className="grid grid-cols-3 gap-4 mb-6">
              {AVATAR_PATHS.map((path, index) => (
                <div
                  key={index}
                  className={`border-4 rounded-full overflow-hidden cursor-pointer transition-all duration-200 ${
                    selectedAvatarPath === path ? 'border-blue-500 shadow-lg scale-105' : 'border-gray-200 hover:border-blue-300'
                  }`}
                  onClick={() => handleAvatarSelect(path)}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}${path}`} // Use PUBLIC_URL for local assets
                    alt={`Avatar ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
            <p className="text-center text-sm text-gray-600">
              Selected: <span className="font-semibold">{selectedAvatarPath.split('/').pop()}</span>
            </p>
          </div>
        </div>
      )}
    </main>
  );
};

export default ProfileSection;